import InteresesJobPage from "./InteresesJobPage";

export {InteresesJobPage}
export default InteresesJobPage
